import src from "IMAGE";
export default { src, width: 413, height: 122, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAIAAADq9gq6AAAAPUlEQVR42gEyAM3/ACgoKGJiYiUlJS8wMC8vLy0tLSoqKhgYGAAzMzN6enovLy9JSko6Ojo+Pj46OjoeHh7/IgpY5p/6ywAAAABJRU5ErkJggg=="};
